import ComingSoon from "app/components/common/ComingSoon";

export default function ProfileUpdateRequest() {
  return <ComingSoon />;
}
